import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useOutletContext } from "react-router-dom";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import PaginatedSortableTable from "../components/PaginatedSortableTable";
import DateTimeRangePicker from "../components/DateTimeRangePicker";
import {
  getInitialDateTimeRange,
  getPresetDateTimeRange,
} from "../utils/dateRange";
dayjs.extend(utc);
dayjs.extend(timezone);

export default function TransferLog({ TransType }) {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const initialRange = getInitialDateTimeRange();
  const [startDateTime, setStartDateTime] = useState(initialRange.start);
  const [endDateTime, setEndDateTime] = useState(initialRange.end);
  const { setIsLoggedIn } = useOutletContext();
  const navigate = useNavigate();
  const [totalLogs, setToTalLogs] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState("");

  const filteredLogs = !searchKeyword.trim()
    ? totalLogs ?? []
    : (totalLogs ?? []).filter((log) => {
        const keyword = searchKeyword.toLowerCase();
        return (
          log.fromId?.toLowerCase().includes(keyword) ||
          log.toId?.toLowerCase().includes(keyword)
        );
      });
  const fmtDate = (ms) => dayjs(ms).tz("Asia/Seoul").format("YYYY-MM-DD");
  const fmtTime = (ms) =>
    dayjs(ms).tz("Asia/Seoul").format("HH:mm:ss") + " UTC +9";

  const sortOptions = [
    { value: "reg_dt:asc", label: "처리시간 - 내림차순" },
    { value: "reg_dt:desc", label: "처리시간 - 오름차순" },
  ];

  const handleDateRange = (type) => {
    const range = getPresetDateTimeRange(type);
    setStartDateTime(range.start);
    setEndDateTime(range.end);
  };

  useEffect(() => {
    fetchTotalTransaction();
  }, [TransType, startDateTime, endDateTime]);

  const fetchTotalTransaction = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API_BASE}/api/TransferData`, {
        params: {
          type: TransType,
          reg_at_start: startDateTime.replace("T", " ") + ":00",
          reg_at_end: endDateTime.replace("T", " ") + ":59",
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setToTalLogs(res.data.logs);
    } catch (err) {
      if (axios.isAxiosError(err) && err.response) {
        if (
          err.response.status === 401 ||
          err.response.status === 403 ||
          err.response.status === 500
        ) {
          localStorage.removeItem("token");
          setIsLoggedIn(false); // 로그인 상태 false 처리
          navigate("/login"); // 로그인 화면으로 리다이렉트
          return;
        }
      }
      console.error("조회 실패:", err);
    }
  };

  const renderRow = (log, idx) => {
    if (!totalLogs || totalLogs.length === 0) {
      return (
        <tr>
          <td className="text-center span-cell-emt" colSpan="14">
            <div className="nk-order-ovwg-ck text-red">
              <h5>조회된 정보가 없습니다.</h5>
            </div>
          </td>
        </tr>
      );
    }
    return (
      <tr key={log.idx} data-pos-y={idx}>
        <td
          className="doubleUser"
          colSpan="1"
          data-columns="id8cac049a3e0f4-col-0"
          data-hint="전송인"
          data-org-colspan="1"
          data-pos-x="0"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <div className="hstack">
            <span
              className="user-toggle"
              style={{
                display: "inline-block",
              }}
            >
              <a className="dropdown-toggle" data-bs-toggle="dropdown" href="#">
                <div className="user-toggle">
                  <div className="user-info">
                    <em className="badge rounded-pill badge-dim bg-outline-info me-1 simm">
                      S
                    </em>
                    <span
                      className={`${log.from_level == 0 ? "super" : "M" +log.from_level} badge me-1`}
                      data-bs-original-title={log.from_level == 0 ? "super" : "M" +log.from_level}
                      data-bs-toggle="tooltip"
                      data-placement="top"
                    >
                      {log.from_level == 0 ? "super" : "M" +log.from_level}
                    </span>
                    <div className="user-name dropdown-indicator">
                      {log.fromId}
                    </div>
                    <div className="user-status text-start">{log.fromId}</div>
                  </div>
                </div>
              </a>
              <div className="dropdown-menu dropdown-menu-start">
                <ul className="link-check">
                  <li>
                    <div className="p-1">
                      <div className="user-name">
                        <span className="badge rounded-pill badge-dim bg-outline-info me-1">
                          지갑
                        </span>
                        <em className="badge rounded-pill badge-dim bg-outline-info me-1 simm">
                          S
                        </em>
                      </div>
                      <div className="user-name">
                        <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                          아이디
                        </span>{" "}
                        {log.fromId}
                      </div>
                      <div className="user-name">
                        <span className="badge rounded-pill badge-dim bg-outline-primary me-1">
                          닉네임
                        </span>{" "}
                        {log.fromId}
                      </div>
                    </div>
                  </li>
                  <li className="divider" />
                  <li>
                    <a href="#">
                      <em className="icon ni ni-info" />
                      <span>자세히</span>
                    </a>
                  </li>
                  <li className="divider" />
                  <li>
                    <a href="#">
                      <em className="icon far fa-copy" />
                      <span>아이디 복사</span>
                    </a>
                  </li>
                </ul>
              </div>
            </span>
            <div className="nk-tnx-type-icon bg-danger-dim text-danger">
              <i className="fas fa-arrow-right" />
            </div>
            <span
              className="user-toggle"
              style={{
                display: "inline-block",
              }}
            >
              <a className="dropdown-toggle" data-bs-toggle="dropdown" href="#">
                <div className="user-toggle">
                  <div className="user-info">
                    <em className="badge rounded-pill badge-dim bg-outline-info me-1 simm">
                      S
                    </em>
                    <span
                      className={`${log.to_level == 0 ? "super" : "M" +log.to_level} badge me-1`}
                      data-bs-original-title="M1"
                      data-bs-toggle="tooltip"
                      data-placement="top"
                    >
                      {log.to_level == 0 ? "super" : "M" +log.to_level}
                    </span>
                    <div className="user-name dropdown-indicator">
                      {log.toId}
                    </div>
                    <div className="user-status text-start">{log.toId}</div>
                  </div>
                </div>
              </a>
              <div className="dropdown-menu dropdown-menu-start">
                <ul className="link-check">
                  <li>
                    <div className="p-1">
                      <div className="user-name">
                        <span className="badge rounded-pill badge-dim bg-outline-info me-1">
                          지갑
                        </span>
                        <em className="badge rounded-pill badge-dim bg-outline-info me-1 simm">
                          S
                        </em>
                      </div>
                      <div className="user-name">
                        <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                          아이디
                        </span>{" "}
                        {log.toId}
                      </div>
                      <div className="user-name">
                        <span className="badge rounded-pill badge-dim bg-outline-primary me-1">
                          닉네임
                        </span>{" "}
                        {log.toId}
                      </div>
                    </div>
                  </li>
                  <li className="divider" />
                  <li>
                    <a href="#">
                      <em className="icon ni ni-info" />
                      <span>자세히</span>
                    </a>
                  </li>
                  <li className="divider" />
                  <li>
                    <a href="#">
                      <em className="icon far fa-copy" />
                      <span>아이디 복사</span>
                    </a>
                  </li>
                </ul>
              </div>
            </span>
          </div>
        </td>
        <td
          className="text-center"
          colSpan="1"
          data-columns="id8cac049a3e0f4-col-1"
          data-org-colspan="1"
          data-pos-x="1"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <span
            className={`badge rounded-pill bg-${
              log.type == 0 ? "pink" : "info"
            }`}
          >
            {log.type == 0 ? "하부에 지급" : "하부를 회수"}
          </span>
          <br />{" "}
        </td>
        <td
          className="text-start fw-bold"
          colSpan="1"
          data-columns="id8cac049a3e0f4-col-2"
          data-hint="형식"
          data-org-colspan="1"
          data-pos-x="2"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          지급 - {log.fromId} <hr className="m-0" /> 증가 - {log.toId}
        </td>
        <td
          className="text-center"
          colSpan="1"
          data-columns="id8cac049a3e0f4-col-3"
          data-org-colspan="1"
          data-pos-x="3"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          KRW <hr className="m-0" /> KRW
        </td>
        <td
          className="text-end"
          colSpan="1"
          data-columns="id8cac049a3e0f4-col-4"
          data-org-colspan="1"
          data-pos-x="4"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <span>
            <span>{log.from_before_cash.toLocaleString()}</span>
          </span>
          <hr className="m-0" />
          <span>
            <span>{log.to_before_cash.toLocaleString()}</span>
          </span>
        </td>
        <td
          className="text-end"
          colSpan="1"
          data-columns="id8cac049a3e0f4-col-5"
          data-org-colspan="1"
          data-pos-x="5"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <span>{(-log.cash).toLocaleString()}</span>
          <hr className="m-0" />
          <span>{log.cash.toLocaleString()}</span>
        </td>
        <td
          className="text-end"
          colSpan="1"
          data-columns="id8cac049a3e0f4-col-6"
          data-org-colspan="1"
          data-pos-x="6"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <span>
            <span>{log.from_after_cash.toLocaleString()}</span>
          </span>
          <hr className="m-0" />
          <span>
            <span>{log.to_after_cash.toLocaleString()}</span>
          </span>
        </td>
        <td
          className="text-center"
          colSpan="1"
          data-columns="id8cac049a3e0f4-col-7"
          data-org-colspan="1"
          data-pos-x="7"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <span style={{ fontSize: "95%" }}>
            {fmtDate(log.reg_dt)}
            <font className="dateInHour"> ({fmtTime(log.reg_dt)})</font>
          </span>
        </td>
      </tr>
    );
  };

  return (
    <div className="nk-content user_view_wrap">
      <div className="container-fluid">
        <div className="nk-content-inner">
          <div className="nk-content-body">
            <div className="nk-block nk-block-lg vTrxsAll" id="opt-x">
              <div className="card card-bordered">
                <div className="card-inner-group">
                  <div className="card-inner p-3">
                    <div className="nk-block nk-block-lg">
                      <form
                        className="mb-0"
                        onSubmit={(e) => {
                          e.preventDefault();
                          fetchTotalTransaction();
                        }}
                      >
                        <DateTimeRangePicker
                          startDateTime={startDateTime}
                          endDateTime={endDateTime}
                          onStartChange={setStartDateTime}
                          onEndChange={setEndDateTime}
                          onPresetChange={handleDateRange}
                        >
                          <div className="col-12 col-sm-6 col-lg-6 col-xl-4 col-xxl-3">
                            <div className="form-control-wrap">
                              <div
                                className="input-group"
                                style={{
                                  flexWrap: "nowrap",
                                }}
                              >
                                <div className="input-group-prepend">
                                  <div className="btn btn-primary">아이디</div>
                                </div>
                                <input
                                  aria-label="검색어"
                                  className="form-control"
                                  placeholder="검색어"
                                  type="text"
                                  value={searchKeyword}
                                  onChange={(e) =>
                                    setSearchKeyword(e.target.value)
                                  }
                                />
                                <div className="input-group-append">
                                  <button
                                    type="submit"
                                    className="btn btn-outline-primary btn-dim"
                                  >
                                    <em className="icon ni ni-search me-2" />{" "}
                                    검색
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </DateTimeRangePicker>
                      </form>
                    </div>
                  </div>
                  <div className="card-inner tableBox px-0 pb-0">
                    <div className="table-wrapper">
                      <div className="table-responsive">
                        <div data-pattern="priority-columns">
                          <table
                            cellSpacing="0"
                            className="table table-small-font table-tighten table-bordered table-striped"
                          >
                            <thead>
                              <tr data-pos-y="0">
                                <th
                                  data-pos-x="0"
                                  data-priority="1"
                                  id="id6fa3382bdd5718-col-0"
                                  style={{
                                    display: "table-cell",
                                  }}
                                >
                                  <span className="sub-text text-center">
                                    정보
                                  </span>
                                </th>
                                <th
                                  data-pos-x="1"
                                  data-priority="1"
                                  id="id6fa3382bdd5718-col-1"
                                  style={{
                                    display: "table-cell",
                                  }}
                                >
                                  <span className="sub-text text-center">
                                    내용
                                  </span>
                                </th>
                                <th
                                  data-pos-x="2"
                                  data-priority="1"
                                  id="id6fa3382bdd5718-col-2"
                                  style={{
                                    display: "table-cell",
                                  }}
                                >
                                  <span className="sub-text text-center">
                                    형식
                                  </span>
                                </th>
                                <th
                                  data-pos-x="3"
                                  data-priority="1"
                                  id="id6fa3382bdd5718-col-3"
                                  style={{
                                    display: "table-cell",
                                  }}
                                >
                                  <span className="sub-text text-center">
                                    화폐
                                  </span>
                                </th>
                                <th
                                  data-pos-x="4"
                                  data-priority="1"
                                  id="id6fa3382bdd5718-col-4"
                                  style={{
                                    display: "table-cell",
                                  }}
                                >
                                  <span className="sub-text text-center">
                                    이전
                                  </span>
                                </th>
                                <th
                                  data-pos-x="5"
                                  data-priority="1"
                                  id="id6fa3382bdd5718-col-5"
                                  style={{
                                    display: "table-cell",
                                  }}
                                >
                                  <span className="sub-text text-center">
                                    금액
                                  </span>
                                </th>
                                <th
                                  data-pos-x="6"
                                  data-priority="1"
                                  id="id6fa3382bdd5718-col-6"
                                  style={{
                                    display: "table-cell",
                                  }}
                                >
                                  <span className="sub-text text-center">
                                    이후
                                  </span>
                                </th>
                                <th
                                  data-pos-x="7"
                                  data-priority="1"
                                  id="id6fa3382bdd5718-col-7"
                                  style={{
                                    display: "table-cell",
                                  }}
                                >
                                  <span className="sub-text text-center">
                                    처리일자
                                  </span>
                                </th>
                              </tr>
                            </thead>

                            {totalLogs && (
                              <PaginatedSortableTable
                                data={filteredLogs}
                                renderRow={renderRow}
                                defaultSortField="reg_dt"
                                defaultSortOrder="desc"
                                sortOptions={sortOptions}
                              />
                            )}
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
